<script lang="ts">
    import { glosbeTranslateIsDictionarySupported } from "@app/components/AutomaticTranslation/GlosbeTranslate-supportedLanguages";
    import GlosbeTranslatePresenter from "@app/components/AutomaticTranslation/GlosbeTranslatePresenter.svelte";
    import { googleTranslateIsDictionarySupported } from "@app/components/AutomaticTranslation/GoogleTranslate-supportedLanguages";
    import GoogleTranslatePresenter from "@app/components/AutomaticTranslation/GoogleTranslatePresenter.svelte";
    import { dictionary } from "@app/services/currentDictionary.service";
    import { DICTIONARY__copiedToClipboard, DICTIONARY__machineTranslation__title, SEARCH__searchBoxPlaceholder__translate } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { searchPhrase } from "../Search.store";
    import CopyToClipboardIcon from "@app/components/Icons/CopyToClipboardIcon.svelte";
    import { copyToClipboard } from "@app/utils/copyToClipboard";
    import { GOOGLE_PROVIDER_NAME } from "@app/components/AutomaticTranslation/GoogleAutomaticTranslationProvider";
    import { GLOSBE_PROVIDER_NAME } from "@app/components/AutomaticTranslation/GlosbeAutomaticTranslationProvider";
    import { getLastAutomaticTranslationResultForProvider } from "@app/components/AutomaticTranslation/AutomaticTranslation.service";
    import { addFloatingMessage } from "@app/components/FloatingMessages/FloatingMessages.controller";
    let hasGoogleTranslate = false;
    let hasGlosbeTranslate = false;
    dictionary.subscribe((dict) => {
        hasGlosbeTranslate = glosbeTranslateIsDictionarySupported(
            dict.l1.code,
            dict.l2.code
        );
        hasGoogleTranslate = googleTranslateIsDictionarySupported(
            dict.l1.code,
            dict.l2.code
        );
    });

    let glosbeTranslateElement: HTMLElement;
    let googleTranslateElement: HTMLElement;

    function onCopyToClipboard(providerName: string) {
        const results = getLastAutomaticTranslationResultForProvider(providerName);
        if (results) {
            copyToClipboard(results.result.text);
            addFloatingMessage({
                body: "",
                title: getMessage(DICTIONARY__copiedToClipboard),
                type: "info",
                actions: [],
                key: "enter-search-phrase",
            });
        }
    }
</script>

{#if hasGlosbeTranslate || hasGoogleTranslate}
    <div>
        <p class="uppercase text-gray-600 text-xs px-2 pt-4 truncate">
            {getMessage(DICTIONARY__machineTranslation__title, [
                $dictionary.l2.name,
                $dictionary.l1.name,
            ])}
        </p>
        {#if hasGlosbeTranslate}
            <div
                bind:this={glosbeTranslateElement}
                class="px-4 mt-2 flex items-start justify-start"
            >
                <div
                    class="w-4 text-center h-8 flex items-center justify-center select-none"
                >
                    <img
                        src="/assets/images/logo-glosbe-translate.svg"
                        loading="lazy"
                        alt="Glosbe translate"
                        class="inline overflow-hidden w-4 h-4"
                    />
                </div>
                <div class="min-h-8 break-words flex-1 p-1">
                    <p class=" min-h-8 break-words flex-1 px-2">
                        <GlosbeTranslatePresenter
                            phrase={$searchPhrase}
                            containerElement={glosbeTranslateElement}
                            linkify={false}
                        />
                    </p>

                    <button
                        class=" text-gray-500 focus:outline-none dir-aware-float-right w-10 h-10 flex items-center justify-center"
                        on:click={() => onCopyToClipboard(GLOSBE_PROVIDER_NAME)}
                        ><CopyToClipboardIcon width="2rem" height="2rem"/>
                    </button>
                    <div class="dir-aware-float-right select-none h-10 flex items-center px-2">
                        <span
                            class="inline-block text-xs text-gray-500"
                            dir="ltr"
                        >
                            Glosbe Translate
                        </span>
                    </div>
                    <div class="clear-both" />
                </div>
            </div>
        {/if}
        {#if hasGoogleTranslate}
            {#if hasGlosbeTranslate}
                <div class="border-b border-slate-100" />
            {/if}
            <div
                bind:this={googleTranslateElement}
                class="px-4 mt-2 flex items-start justify-start"
            >
                <div
                    class="w-4 text-center h-8 flex items-center justify-center select-none"
                >
                    <img
                        src="/assets/images/logo-google-translate.svg"
                        loading="lazy"
                        alt="Google translate"
                        class="inline overflow-hidden w-4 h-4"
                    />
                </div>
                <div class="min-h-8 break-words flex-1 p-1">
                    <p class=" min-h-8 break-words flex-1 px-2">
                        <GoogleTranslatePresenter
                            phrase={$searchPhrase}
                            containerElement={googleTranslateElement}
                        />
                    </p>

                    <button
                        class="text-gray-500 focus:outline-none dir-aware-float-right w-10 h-10 flex items-center justify-center"
                        on:click={() => onCopyToClipboard(GOOGLE_PROVIDER_NAME)}
                        ><CopyToClipboardIcon width="2rem" height="2rem"/>
                    </button>
                    <div class="dir-aware-float-right select-none h-10 flex items-center px-2">
                        <span
                            class="inline-block text-xs text-gray-500"
                            dir="ltr"
                        >
                            Google Translate
                        </span>
                    </div>
                    <div class="clear-both" />
                </div>
            </div>
        {/if}
    </div>
{/if}
